module.exports = __webpack_public_path__ + "img/音频暂停键.39889e0e.png";